import { render, staticRenderFns } from "./AgentSidebar.vue?vue&type=template&id=13bfa710&scoped=true&"
import script from "./AgentSidebar.vue?vue&type=script&lang=js&"
export * from "./AgentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AgentSidebar.vue?vue&type=style&index=0&id=13bfa710&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bfa710",
  null
  
)

export default component.exports